<template>
  <GuestLayout>
    <RouterView />
  </GuestLayout>
</template>

<script setup lang="ts">
import GuestLayout from '@/layouts/GuestLayout.vue';
</script>
